import { Button, Result } from "antd";
import View from "components/elements/View";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import { useEffect } from "react";

function NotFound(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", {
        replace: true,
        state: { from: `${location.pathname}${location.search}` },
      });
    }
  }, []);

  return (
    <View>
      {isAuthenticated ? (
        <Result
          status="404"
          title="404"
          subTitle={
            <>
              {t("not_found.page_not_found")}: <strong>{pathname}</strong>
            </>
          }
          extra={
            <Button type="primary" onClick={() => navigate("/")}>
              {t("Back Home")}
            </Button>
          }
        />
      ) : null}
    </View>
  );
}

export default NotFound;
